import script from "./inbox-all-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./inbox-all-panel.vue?vue&type=script&setup=true&lang=js"

import "./inbox-all-panel.vue?vue&type=style&index=0&id=3d099a24&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d099a24"]])

export default __exports__